import BaseCommand from "@/models/api/commands/BaseCommand";
import { TRADE_TERM_APPLY_TO } from "@/static/tradeTermApplyToTypes";

export class ChangeBookingItemTradeTermCommand extends BaseCommand {
  CommandName = "ChangeBookingItemTradeTerm";
  Command: {
    BookingItemTmpId: string;
    TmpId: string;
    Amount: number;
    IsHidden: boolean;
    SeparateItem: boolean;
    ServiceTypeCode: string | null;
    AppliesTo: TRADE_TERM_APPLY_TO | null;
    IsDeleted: boolean;
  };
  constructor(
    sessionId: string,
    operationId: string,
    bookingItemTmpId: string,
    tmpId: string,
    amount: number,
    isHidden: boolean,
    separateItem: boolean,
    serviceTypeCode: string | null,
    appliesTo: TRADE_TERM_APPLY_TO | null,
    isDeleted: boolean
  ) {
    super(sessionId, operationId);
    this.Command = {
      BookingItemTmpId: bookingItemTmpId,
      TmpId: tmpId,
      Amount: amount,
      IsHidden: isHidden,
      SeparateItem: separateItem,
      ServiceTypeCode: serviceTypeCode,
      AppliesTo: appliesTo,
      IsDeleted: isDeleted,
    };
  }
}
